<script lang="ts">
    export let value: string = '';
    export let placeholder: string = 'Search…';
    export let disabled: boolean = false;
    export let label: string = '';
</script>

<div class="form-field" class:form-field--no-label={!label}>
    {#if label}<span class="label-text">{label}</span>{/if}
    <div class="search-wrap">
        <span class="search-icon" aria-hidden="true">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
        </span>
        <input
            class="search-input"
            type="search"
            {placeholder}
            {disabled}
            bind:value
            on:input
            on:change
        />
    </div>
</div>

<style lang="scss">
    .form-field--no-label {
        display: block; // Remove flex-column when no label is present
    }
</style>
